import { Favourites } from '../component/Favourites';
import { Footer } from '../component/Footer';

export const FavoritesPage = () => {
  return (
    <>
      <Favourites />
      <Footer />
    </>
  );
};
